angular.module('zc.agencies')
  .component('zcAgencySettings', {
    templateUrl: '/templates/agencies/settings/agency_settings.html',
    bindings: {
      agency: '<'
    },
    controller: ZcAgencySettingsController
  });

ZcAgencySettingsController.$inject = ['Agency'];
function ZcAgencySettingsController(Agency) {
  const vm = this;

  vm.save = updatedAgency => Agency.update(updatedAgency);
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/agencies/settings/agency_settings.component.js